import React from "react";
import { useDispatch, useStore } from "react-redux";
import RecordButton from "./RecordButton";
import { recordQuestionTableCellChange, ElectronicScaleState } from "./store";
import classes from "./styles.module.scss";

type Column = {
  type: "title" | "field";
  value: string;
  disabled: boolean;
  rowSpan?: number;
  colSpan?: number;
  linkedRow?: number;
  linkedColumn?: number;
};
export type Row = {
  type: "header" | "row";
  columns: Column[];
};

type TableProps = {
  rows?: Row[];
  componentID: number;
};

const Table = ({ rows, componentID }: TableProps) => {
  const dispatch = useDispatch();
  const store = useStore<{
    electronicScaleModal: ElectronicScaleState;
    simulation: {
      scaleWeight: number;
    };
  }>();
  const record = recordQuestionTableCellChange(dispatch, store.getState);

  const row = (r: Row, rIndex: number) => (
    <tr className={r.type}>
      {r.type == "header"
        ? r.columns.map((c) => <th {...c}>{c.value}</th>)
        : r.columns.map((c, colIndex) => (
            <td {...c}>
              <div className={classes["cell-content"]}>
                <span className={classes["cell-value"]}>{c.value}</span>
                {c.type === "field" && (
                  <RecordButton
                    row={rIndex}
                    col={colIndex}
                    disabled={c.disabled}
                    recorded={c.value !== "-"}
                    onRecord={(row, column) =>
                      record(
                        componentID,
                        row,
                        column,
                        c.linkedRow,
                        c.linkedColumn
                      )
                    }
                  />
                )}
              </div>
            </td>
          ))}
    </tr>
  );

  return (
    <div className={classes["table-container"]} tabIndex={-1}>
      <table aria-label="An electronic balance scale with a zero button. There’s a widget for recording the initial mass of dialysis tubes.">
        {rows?.map(row)}
      </table>
    </div>
  );
};

export default Table;
